export enum NoteEventsEnum {
    Refresh = "refreshNote"
}
